import type { Movie } from '@/types';

export const movies: Movie[] = [
  {
    id: 'mv-01',
    title: '星海远征',
    originalTitle: 'Voyage Beyond',
    categoryId: 'movie',
    categoryName: '电影',
    genres: ['科幻', '冒险'],
    region: '中国大陆',
    year: 2026,
    score: 8.6,
    duration: '148分钟',
    director: '陆云舟',
    cast: ['程亦南', '沈砚', '许清和'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20minimal%20poster%20artwork%20of%20a%20lone%20spacecraft%20crossing%20a%20distant%20nebula%20rendered%20in%20deep%20blue%20and%20warm%20amber%20tones%20with%20soft%20film%20grain%20dramatic%20lighting%20elegant%20negative%20space%20and%20consistent%20editorial%20color%20grading&width=600&height=800&seq=hema-mv-01&orientation=portrait',
    summary: '一支深空探测队在木星轨道发现失联十七年的先遣舰残骸，而残骸中传回的信号，似乎来自尚未抵达的将来。队长林澈必须在返航与追寻之间做出选择，一场关于时间、记忆与归途的远征就此展开。',
    featured: true,
  },
  {
    id: 'mv-02',
    title: '雾都疑云',
    categoryId: 'movie',
    categoryName: '电影',
    genres: ['悬疑', '犯罪'],
    region: '中国香港',
    year: 2025,
    score: 8.2,
    duration: '126分钟',
    director: '关维安',
    cast: ['梁sir', '许清和', '陆云舟'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20minimal%20poster%20artwork%20of%20a%20foggy%20harbour%20city%20at%20night%20reflected%20in%20deep%20blue%20and%20warm%20amber%20tones%20with%20soft%20film%20grain%20dramatic%20lighting%20elegant%20negative%20space%20and%20consistent%20editorial%20color%20grading&width=600&height=800&seq=hema-mv-02&orientation=portrait',
    summary: '连环失踪案的重现让退休刑警程默重新回到雨夜街头。随着线索层层剥开，他发现所有受害者都与二十年前那场未结的旧案有关，而真相始终藏在雾气最浓的地方。',
    featured: true,
  },
  {
    id: 'mv-03',
    title: '长夜将尽',
    categoryId: 'movie',
    categoryName: '电影',
    genres: ['剧情'],
    region: '中国大陆',
    year: 2025,
    score: 8.9,
    duration: '132分钟',
    director: '苏怀瑾',
    cast: ['沈砚', '程亦南'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20minimal%20poster%20artwork%20of%20a%20lone%20figure%20walking%20along%20an%20empty%20winter%20road%20at%20dawn%20in%20deep%20blue%20and%20warm%20amber%20tones%20with%20soft%20film%20grain%20dramatic%20lighting%20elegant%20negative%20space%20and%20consistent%20editorial%20color%20grading&width=600&height=800&seq=hema-mv-03&orientation=portrait',
    summary: '北方小城最后一座煤矿即将关停，留守的矿工老周与返乡的女儿在倒计时的三个月里，重新学习如何与彼此告别。一部关于时代转身与亲情和解的沉静之作。',
    featured: true,
  },
  {
    id: 'mv-04',
    title: '逆光而行',
    categoryId: 'movie',
    categoryName: '电影',
    genres: ['动作', '剧情'],
    region: '中国大陆',
    year: 2026,
    score: 7.8,
    duration: '118分钟',
    director: '秦昭',
    cast: ['许清和', '罗子谦'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20minimal%20poster%20artwork%20of%20a%20silhouetted%20runner%20against%20a%20glowing%20sunset%20horizon%20in%20deep%20blue%20and%20warm%20amber%20tones%20with%20soft%20film%20grain%20dramatic%20lighting%20elegant%20negative%20space%20and%20consistent%20editorial%20color%20grading&width=600&height=800&seq=hema-mv-04&orientation=portrait',
    summary: '前马拉松运动员周野在意外后失去奔跑能力，为守护弟弟留下的训练营，他戴上义肢重新站上赛道。汗水与疼痛之中，他跑向的不只是终点，还有被自己放弃的过去。',
  },
  {
    id: 'mv-05',
    title: '时间的褶皱',
    categoryId: 'movie',
    categoryName: '电影',
    genres: ['科幻', '剧情'],
    region: '美国',
    year: 2025,
    score: 8.4,
    duration: '140分钟',
    director: '诺兰风格·艾略特',
    cast: ['艾登·科尔', '玛拉·维恩'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20minimal%20poster%20artwork%20of%20layered%20abstract%20clock%20gears%20folding%20into%20each%20other%20in%20deep%20blue%20and%20warm%20amber%20tones%20with%20soft%20film%20grain%20dramatic%20lighting%20elegant%20negative%20space%20and%20consistent%20editorial%20color%20grading&width=600&height=800&seq=hema-mv-05&orientation=portrait',
    summary: '理论物理学家凯拉发现父亲的旧手表每隔十二小时便会回拨七分钟。循着这些“褶皱”，她逐渐拼凑出一个关于跨时间通信的实验，也拼凑出父亲从未说出口的告别。',
  },
  {
    id: 'mv-06',
    title: '山那边的风',
    categoryId: 'movie',
    categoryName: '电影',
    genres: ['剧情', '爱情'],
    region: '中国大陆',
    year: 2024,
    score: 7.6,
    duration: '112分钟',
    director: '苏怀瑾',
    cast: ['程亦南', '林知夏'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20minimal%20poster%20artwork%20of%20rolling%20green%20terraced%20hills%20under%20soft%20mist%20in%20deep%20blue%20and%20warm%20amber%20tones%20with%20soft%20film%20grain%20dramatic%20lighting%20elegant%20negative%20space%20and%20consistent%20editorial%20color%20grading&width=600&height=800&seq=hema-mv-06&orientation=portrait',
    summary: '支教老师林知夏在滇西山村度过了三年，离开前的最后一个夏天，她与沉默寡言的护林员在山风里相遇。两个都习惯告别的人，第一次想为一个人留下来。',
  },
  {
    id: 'mv-07',
    title: '无声的证词',
    categoryId: 'movie',
    categoryName: '电影',
    genres: ['悬疑', '剧情'],
    region: '韩国',
    year: 2025,
    score: 8.1,
    duration: '124分钟',
    director: '朴在勋',
    cast: ['金敏书', '李宰旭'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20minimal%20poster%20artwork%20of%20an%20empty%20courtroom%20bench%20lit%20by%20a%20single%20window%20in%20deep%20blue%20and%20warm%20amber%20tones%20with%20soft%20film%20grain%20dramatic%20lighting%20elegant%20negative%20space%20and%20consistent%20editorial%20color%20grading&width=600&height=800&seq=hema-mv-07&orientation=portrait',
    summary: '听障女孩是唯一目击证人。手语翻译姜律师在为她辩护的过程中，发现证词背后藏着另一层沉默。当所有人都相信“看见”时，她必须证明“没看见”同样是一种真相。',
  },
  {
    id: 'mv-08',
    title: '夏日回声',
    categoryId: 'movie',
    categoryName: '电影',
    genres: ['爱情', '剧情'],
    region: '日本',
    year: 2024,
    score: 7.9,
    duration: '106分钟',
    director: '小林悠真',
    cast: ['宫崎葵', '高桥凌'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20minimal%20poster%20artwork%20of%20a%20quiet%20seaside%20town%20with%20railway%20tracks%20in%20deep%20blue%20and%20warm%20amber%20tones%20with%20soft%20film%20grain%20dramatic%20lighting%20elegant%20negative%20space%20and%20consistent%20editorial%20color%20grading&width=600&height=800&seq=hema-mv-08&orientation=portrait',
    summary: '高一那年夏天，翔太在废弃的海边车站遇见抱着旧收音机的少女。她把每一段声音都录进磁带，说要寄给未来的自己。多年后，翔太在整理旧物时，收到了其中一盘。',
  },
  {
    id: 'tv-01',
    title: '长安旧梦',
    categoryId: 'tv',
    categoryName: '电视剧',
    genres: ['剧情', '悬疑'],
    region: '中国大陆',
    year: 2026,
    score: 8.7,
    duration: '全40集',
    director: '顾长风',
    cast: ['沈砚', '林知夏', '罗子谦'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20minimal%20poster%20artwork%20of%20ancient%20chinese%20palace%20lanterns%20glowing%20at%20dusk%20in%20deep%20blue%20and%20warm%20amber%20tones%20with%20soft%20film%20grain%20dramatic%20lighting%20elegant%20negative%20space%20and%20consistent%20editorial%20color%20grading&width=600&height=800&seq=hema-tv-01&orientation=portrait',
    summary: '盛唐年间，一桩离奇的灯会命案牵出朝堂暗流。女尚书苏莞与寒门画师裴远联手查案，在繁华长安的光影里，逐步揭开一段被史书刻意抹去的旧梦。',
    featured: true,
  },
  {
    id: 'tv-02',
    title: '暗涌',
    categoryId: 'tv',
    categoryName: '电视剧',
    genres: ['犯罪', '悬疑'],
    region: '中国大陆',
    year: 2025,
    score: 8.3,
    duration: '全32集',
    director: '郑煜',
    cast: ['程亦南', '许清和'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20minimal%20poster%20artwork%20of%20a%20rainy%20city%20overpass%20with%20neon%20reflections%20in%20deep%20blue%20and%20warm%20amber%20tones%20with%20soft%20film%20grain%20dramatic%20lighting%20elegant%20negative%20space%20and%20consistent%20editorial%20color%20grading&width=600&height=800&seq=hema-tv-02&orientation=portrait',
    summary: '经侦警察追查一笔静静流动了八年的灰色资金，线索指向一家看似普通的物流公司。水面之下暗涌的，不只是钱，还有被隐藏的债务、承诺与背叛。',
  },
  {
    id: 'tv-03',
    title: '我们的十年',
    categoryId: 'tv',
    categoryName: '电视剧',
    genres: ['剧情', '爱情'],
    region: '中国大陆',
    year: 2024,
    score: 7.7,
    duration: '全36集',
    director: '苏怀瑾',
    cast: ['林知夏', '陆云舟'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20minimal%20poster%20artwork%20of%20a%20graduation%20photograph%20fading%20into%20autumn%20trees%20in%20deep%20blue%20and%20warm%20amber%20tones%20with%20soft%20film%20grain%20dramatic%20lighting%20elegant%20negative%20space%20and%20consistent%20editorial%20color%20grading&width=600&height=800&seq=hema-tv-03&orientation=portrait',
    summary: '四个大学室友约定每五年聚一次。从毕业到成家，从理想到妥协，十年间三次重逢，他们在彼此身上看见了时间留下的痕迹，也看见了没有被时间带走的东西。',
  },
  {
    id: 'tv-04',
    title: '深蓝档案',
    categoryId: 'tv',
    categoryName: '电视剧',
    genres: ['科幻', '悬疑'],
    region: '英国',
    year: 2026,
    score: 8.5,
    duration: '全24集',
    director: '奥利弗·格兰特',
    cast: ['艾拉·诺曼', '汤姆·哈迪森'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20minimal%20poster%20artwork%20of%20a%20glowing%20data%20server%20corridor%20under%20deep%20ocean%20blue%20light%20in%20deep%20blue%20and%20warm%20amber%20tones%20with%20soft%20film%20grain%20dramatic%20lighting%20elegant%20negative%20space%20and%20consistent%20editorial%20color%20grading&width=600&height=800&seq=hema-tv-04&orientation=portrait',
    summary: '海底数据中心意外唤醒了被标注为“深蓝”的旧档案。档案管理员艾拉发现，里面记录着尚未发生的事件，而每一个被记录的名字，都在倒数。',
  },
  {
    id: 'tv-05',
    title: '归途',
    categoryId: 'tv',
    categoryName: '电视剧',
    genres: ['剧情'],
    region: '中国大陆',
    year: 2025,
    score: 8.0,
    duration: '全28集',
    director: '顾长风',
    cast: ['罗子谦', '程亦南'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20minimal%20poster%20artwork%20of%20a%20highway%20stretching%20toward%20a%20distant%20hometown%20at%20dusk%20in%20deep%20blue%20and%20warm%20amber%20tones%20with%20soft%20film%20grain%20dramatic%20lighting%20elegant%20negative%20space%20and%20consistent%20editorial%20color%20grading&width=600&height=800&seq=hema-tv-05&orientation=portrait',
    summary: '长途货车司机老赵跑完最后一趟货运，决定回到二十年没回过的老家。一路上他载过的乘客、听过的故事，逐渐拼出他当年离开的真相，也拼出一条迟到了很久的归途。',
  },
  {
    id: 'tv-06',
    title: '光年之外的信',
    categoryId: 'tv',
    categoryName: '电视剧',
    genres: ['科幻', '爱情'],
    region: '美国',
    year: 2025,
    score: 8.1,
    duration: '全20集',
    director: '玛拉·维恩',
    cast: ['艾登·科尔', '索菲亚·雷'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20minimal%20poster%20artwork%20of%20a%20handwritten%20letter%20drifting%20through%20starlit%20space%20in%20deep%20blue%20and%20warm%20amber%20tones%20with%20soft%20film%20grain%20dramatic%20lighting%20elegant%20negative%20space%20and%20consistent%20editorial%20color%20grading&width=600&height=800&seq=hema-tv-06&orientation=portrait',
    summary: '地球与殖民星之间信号单程需要四年。通信员安娜每天写下无法寄出的信，直到某天收到一封来自“四年后”的回信——署名正是她自己。',
  },
  {
    id: 'tv-07',
    title: '诊室风云',
    categoryId: 'tv',
    categoryName: '电视剧',
    genres: ['剧情', '喜剧'],
    region: '中国大陆',
    year: 2024,
    score: 7.5,
    duration: '全30集',
    director: '秦昭',
    cast: ['许清和', '林知夏'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20minimal%20poster%20artwork%20of%20a%20warm%20lit%20hospital%20corridor%20at%20night%20in%20deep%20blue%20and%20warm%20amber%20tones%20with%20soft%20film%20grain%20dramatic%20lighting%20elegant%20negative%20space%20and%20consistent%20editorial%20color%20grading&width=600&height=800&seq=hema-tv-07&orientation=portrait',
    summary: '社区医院内科诊室里，几位性格各异的年轻医生每天面对的不是疑难杂症，而是柴米油盐、家庭矛盾与人生抉择。治愈别人的同时，他们也在慢慢治愈自己。',
  },
  {
    id: 'va-01',
    title: '星厨驾到',
    categoryId: 'variety',
    categoryName: '综艺',
    genres: ['纪实', '喜剧'],
    region: '中国大陆',
    year: 2026,
    score: 8.0,
    duration: '全12期',
    director: '综艺组',
    cast: ['陆云舟', '林知夏'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20minimal%20poster%20artwork%20of%20a%20chef%20plating%20a%20dish%20under%20warm%20spotlight%20in%20deep%20blue%20and%20warm%20amber%20tones%20with%20soft%20film%20grain%20dramatic%20lighting%20elegant%20negative%20space%20and%20consistent%20editorial%20color%20grading&width=600&height=800&seq=hema-va-01&orientation=portrait',
    summary: '八位来自不同菜系的厨师走进同一间开放式厨房，每期围绕一个城市主题完成限时挑战。烟火气里较量的是手艺，打动的却是味道背后的记忆。',
  },
  {
    id: 'va-02',
    title: '极限出发',
    categoryId: 'variety',
    categoryName: '综艺',
    genres: ['冒险', '纪实'],
    region: '中国大陆',
    year: 2025,
    score: 7.8,
    duration: '全10期',
    director: '综艺组',
    cast: ['罗子谦', '程亦南'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20minimal%20poster%20artwork%20of%20mountain%20climbers%20crossing%20a%20narrow%20ridge%20at%20sunrise%20in%20deep%20blue%20and%20warm%20amber%20tones%20with%20soft%20film%20grain%20dramatic%20lighting%20elegant%20negative%20space%20and%20consistent%20editorial%20color%20grading&width=600&height=800&seq=hema-va-02&orientation=portrait',
    summary: '六位嘉宾只带一张地图和有限补给，穿越高原、峡谷与沙漠。节目不设淘汰，只设“出发”——当他们把恐惧留在身后，风景才真正开始。',
  },
  {
    id: 'va-03',
    title: '声动全场',
    categoryId: 'variety',
    categoryName: '综艺',
    genres: ['音乐', '喜剧'],
    region: '中国大陆',
    year: 2026,
    score: 8.2,
    duration: '全14期',
    director: '综艺组',
    cast: ['沈砚', '许清和'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20minimal%20poster%20artwork%20of%20a%20singer%20silhouetted%20before%20warm%20stage%20lights%20in%20deep%20blue%20and%20warm%20amber%20tones%20with%20soft%20film%20grain%20dramatic%20lighting%20elegant%20negative%20space%20and%20consistent%20editorial%20color%20grading&width=600&height=800&seq=hema-va-03&orientation=portrait',
    summary: '素人歌手与职业音乐人盲选配对，每期改编一首经典老歌。没有胜负规则，只有舞台；当两种声音真正合上，音乐便有了新的答案。',
  },
  {
    id: 'va-04',
    title: '奇思妙想营',
    categoryId: 'variety',
    categoryName: '综艺',
    genres: ['喜剧', '纪实'],
    region: '中国大陆',
    year: 2024,
    score: 7.4,
    duration: '全12期',
    director: '综艺组',
    cast: ['林知夏', '罗子谦'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20minimal%20poster%20artwork%20of%20colourful%20handmade%20gadgets%20on%20a%20workbench%20in%20deep%20blue%20and%20warm%20amber%20tones%20with%20soft%20film%20grain%20dramatic%20lighting%20elegant%20negative%20space%20and%20consistent%20editorial%20color%20grading&width=600&height=800&seq=hema-va-04&orientation=portrait',
    summary: '一群孩子在营地里用最朴素的材料，把天马行空的想法变成能跑能跳的小发明。真正被启发的不止是他们，还有屏幕前每一个重新学会提问的大人。',
  },
  {
    id: 'doc-01',
    title: '大地脉动',
    categoryId: 'documentary',
    categoryName: '纪录片',
    genres: ['纪实'],
    region: '中国大陆',
    year: 2026,
    score: 9.1,
    duration: '全6集',
    director: '纪录团队',
    cast: ['解说：程亦南'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20minimal%20poster%20artwork%20of%20vast%20misty%20mountain%20ranges%20and%20rivers%20seen%20from%20above%20in%20deep%20blue%20and%20warm%20amber%20tones%20with%20soft%20film%20grain%20dramatic%20lighting%20elegant%20negative%20space%20and%20consistent%20editorial%20color%20grading&width=600&height=800&seq=hema-doc-01&orientation=portrait',
    summary: '摄制组用四年时间横跨六大地理带，记录山川、河流与湿地如何在季节里呼吸。这不是关于风景的影像，而是关于我们脚下这片土地缓慢而持续的脉动。',
  },
  {
    id: 'doc-02',
    title: '千年匠心',
    categoryId: 'documentary',
    categoryName: '纪录片',
    genres: ['纪实'],
    region: '中国大陆',
    year: 2025,
    score: 8.8,
    duration: '全8集',
    director: '纪录团队',
    cast: ['解说：沈砚'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20minimal%20poster%20artwork%20of%20a%20craftsman%20hands%20shaping%20pottery%20by%20warm%20lamp%20light%20in%20deep%20blue%20and%20warm%20amber%20tones%20with%20soft%20film%20grain%20dramatic%20lighting%20elegant%20negative%20space%20and%20consistent%20editorial%20color%20grading&width=600&height=800&seq=hema-doc-02&orientation=portrait',
    summary: '从竹刻到窑烧，从缂丝到古法造纸，八位手艺人用一生的时间，与一件器物反复相处。镜头安静地记录下，什么是“慢”里藏着的时间。',
  },
  {
    id: 'doc-03',
    title: '深海之下',
    categoryId: 'documentary',
    categoryName: '纪录片',
    genres: ['纪实', '冒险'],
    region: '英国',
    year: 2025,
    score: 8.9,
    duration: '全5集',
    director: '奥利弗·格兰特',
    cast: ['解说：艾拉·诺曼'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20minimal%20poster%20artwork%20of%20bioluminescent%20deep%20sea%20creatures%20in%20dark%20water%20in%20deep%20blue%20and%20warm%20amber%20tones%20with%20soft%20film%20grain%20dramatic%20lighting%20elegant%20negative%20space%20and%20consistent%20editorial%20color%20grading&width=600&height=800&seq=hema-doc-03&orientation=portrait',
    summary: '潜航器下潜到六千米的黑暗海沟，探照灯扫过之处，是发光的生物、沉默的沉船与从未被记录的洋流。人类对海洋的了解，或许还不如对月球的了解多。',
  },
  {
    id: 'doc-04',
    title: '城市夜行',
    categoryId: 'documentary',
    categoryName: '纪录片',
    genres: ['纪实'],
    region: '中国大陆',
    year: 2024,
    score: 8.5,
    duration: '全4集',
    director: '纪录团队',
    cast: ['解说：许清和'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20minimal%20poster%20artwork%20of%20an%20empty%20city%20street%20at%20midnight%20with%20warm%20streetlights%20in%20deep%20blue%20and%20warm%20amber%20tones%20with%20soft%20film%20grain%20dramatic%20lighting%20elegant%20negative%20space%20and%20consistent%20editorial%20color%20grading&width=600&height=800&seq=hema-doc-04&orientation=portrait',
    summary: '当大多数人睡去，另一群人开始工作：代驾、便利店店员、环卫工人、急诊医生。四座城市的四个夜晚，讲述那些在灯光之外维持城市运转的人。',
  },
  {
    id: 'an-01',
    title: '云端旅人',
    categoryId: 'anime',
    categoryName: '动漫',
    genres: ['动画', '冒险'],
    region: '日本',
    year: 2026,
    score: 8.7,
    duration: '全24集',
    director: '小林悠真',
    cast: ['配音：宫崎葵', '配音：高桥凌'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20minimal%20anime%20poster%20artwork%20of%20a%20girl%20gliding%20on%20a%20small%20airship%20through%20clouds%20in%20deep%20blue%20and%20warm%20amber%20tones%20with%20soft%20film%20grain%20dramatic%20lighting%20elegant%20negative%20space%20and%20consistent%20editorial%20color%20grading&width=600&height=800&seq=hema-an-01&orientation=portrait',
    summary: '在漂浮于云海之上的群岛世界，少女飞儿驾驶着祖父留下的古董飞艇，寻找传说中沉入云底的大陆。每到达一座岛，她就多明白一点“家”的含义。',
  },
  {
    id: 'an-02',
    title: '机械之心',
    categoryId: 'anime',
    categoryName: '动漫',
    genres: ['动画', '科幻'],
    region: '中国大陆',
    year: 2025,
    score: 8.4,
    duration: '全20集',
    director: '国漫团队',
    cast: ['配音：沈砚', '配音：林知夏'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20minimal%20anime%20poster%20artwork%20of%20a%20gentle%20robot%20holding%20a%20glowing%20seed%20in%20deep%20blue%20and%20warm%20amber%20tones%20with%20soft%20film%20grain%20dramatic%20lighting%20elegant%20negative%20space%20and%20consistent%20editorial%20color%20grading&width=600&height=800&seq=hema-an-02&orientation=portrait',
    summary: '战后废墟里，一台被遗弃的维修机器人捡到一颗种子。它不知道植物如何生长，只知道必须找到阳光。于是它带着种子，走上了穿过四座废城的漫长旅程。',
  },
  {
    id: 'an-03',
    title: '星尘物语',
    categoryId: 'anime',
    categoryName: '动漫',
    genres: ['动画', '剧情'],
    region: '日本',
    year: 2025,
    score: 8.9,
    duration: '全12集',
    director: '岩井澄',
    cast: ['配音：高桥凌', '配音：宫崎葵'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20minimal%20anime%20poster%20artwork%20of%20a%20boy%20on%20a%20telescope%20hill%20under%20a%20meteor%20shower%20in%20deep%20blue%20and%20warm%20amber%20tones%20with%20soft%20film%20grain%20dramatic%20lighting%20elegant%20negative%20space%20and%20consistent%20editorial%20color%20grading&width=600&height=800&seq=hema-an-03&orientation=portrait',
    summary: '住在山顶天文台的少年每晚记录流星。他相信每一颗坠落的星，都藏着一个人未说完的话。直到某颗流星落下，带来一个只属于夜晚的少女。',
  },
  {
    id: 'an-04',
    title: '森林守护者',
    categoryId: 'anime',
    categoryName: '动漫',
    genres: ['动画', '冒险'],
    region: '中国大陆',
    year: 2024,
    score: 8.0,
    duration: '全16集',
    director: '国漫团队',
    cast: ['配音：程亦南', '配音：罗子谦'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20minimal%20anime%20poster%20artwork%20of%20a%20small%20guardian%20spirit%20among%20towering%20ancient%20trees%20in%20deep%20blue%20and%20warm%20amber%20tones%20with%20soft%20film%20grain%20dramatic%20lighting%20elegant%20negative%20space%20and%20consistent%20editorial%20color%20grading&width=600&height=800&seq=hema-an-04&orientation=portrait',
    summary: '千年古林正在枯萎，被选中的少年带着一枚会说话的松果，踏上寻找“林之心”的路。他要守护的不只是树木，还有人与自然曾经许下的约定。',
  },
  {
    id: 'sh-01',
    title: '一分钟城市',
    categoryId: 'short',
    categoryName: '短片',
    genres: ['剧情', '纪实'],
    region: '中国大陆',
    year: 2026,
    score: 7.9,
    duration: '片长 8 分钟',
    director: '新锐导演·夏木',
    cast: ['林知夏'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20minimal%20short%20film%20poster%20artwork%20of%20a%20busy%20crosswalk%20frozen%20in%20one%20second%20in%20deep%20blue%20and%20warm%20amber%20tones%20with%20soft%20film%20grain%20dramatic%20lighting%20elegant%20negative%20space%20and%20consistent%20editorial%20color%20grading&width=600&height=800&seq=hema-sh-01&orientation=portrait',
    summary: '一座城市，一百个路人，每人一秒。导演把同一个十字路口的六十秒拆成六十个瞬间，拼出一个关于陌生人如何彼此路过、彼此照亮的温柔标本。',
  },
  {
    id: 'sh-02',
    title: '窗',
    categoryId: 'short',
    categoryName: '短片',
    genres: ['剧情'],
    region: '法国',
    year: 2025,
    score: 8.3,
    duration: '片长 14 分钟',
    director: '卡米耶·罗',
    cast: ['苏菲·德兰'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20minimal%20short%20film%20poster%20artwork%20of%20a%20single%20apartment%20window%20glowing%20at%20night%20in%20deep%20blue%20and%20warm%20amber%20tones%20with%20soft%20film%20grain%20dramatic%20lighting%20elegant%20negative%20space%20and%20consistent%20editorial%20color%20grading&width=600&height=800&seq=hema-sh-02&orientation=portrait',
    summary: '独居老人每天在窗前看对面的楼。某天对面窗里的人影消失了。她犹豫了很久，终于第一次走出了自己的房间。十四分钟，一个关于靠近的寓言。',
  },
  {
    id: 'sh-03',
    title: '最后一班地铁',
    categoryId: 'short',
    categoryName: '短片',
    genres: ['剧情', '悬疑'],
    region: '中国香港',
    year: 2024,
    score: 7.6,
    duration: '片长 11 分钟',
    director: '新锐导演·何一鸣',
    cast: ['梁sir', '许清和'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20minimal%20short%20film%20poster%20artwork%20of%20an%20empty%20subway%20carriage%20under%20warm%20flickering%20light%20in%20deep%20blue%20and%20warm%20amber%20tones%20with%20soft%20film%20grain%20dramatic%20lighting%20elegant%20negative%20space%20and%20consistent%20editorial%20color%20grading&width=600&height=800&seq=hema-sh-03&orientation=portrait',
    summary: '深夜末班地铁上只剩两个人。一个疲惫的上班族，一个始终望着窗外的陌生人。当列车驶过本该停靠的站台，上班族意识到，今晚的地铁不打算回家。',
  },
];